import { trpc } from '@/shared/api';

/** HOME 추천 목록(products.listHomeRecommended) — 1번째는 히어로 카드, 전체는 추천 상품 섹션. */
export const useHomeRecommendedProductsQuery = () => trpc.products.listHomeRecommended.useQuery();
